import React, { useEffect, useState, useTransition } from 'react';
import { getContextFromWindow } from './context';
import { onChangeAuthState, onChangeIdToken } from 'services/auth';
import { documentSetCookie, documentGetCookie } from '../../cookie';

export const UserContext = React.createContext({});
UserContext.displayName = 'User';

export const getUserFields = ({
  email,
  name,
  banned,
  premium,
  promptedrun,
  dumpert_id: dumpertId,
  role,
  hashed_email: hashedEmail,
  hashed_id: hashedId,
}) => ({
  email,
  name,
  banned,
  role,
  deluxe: premium,
  promptedrun,
  dumpertId,
  hashedEmail,
  hashedId,
  moderate: role === 'admin' || role === 'moderator',
});

export const UserContextProvider = ({ staticContext, children }) => {
  const contextUser = (staticContext || {}).user || getContextFromWindow().user || null;

  // TODO (MINOR): consider to remove 'initiailized' property
  //  initiailized can be false on server side only if the user is not logged in
  //  then if it is initiailized on client but user always is not logged in in that case
  //  because if user is logged in then it is always initiailized on server side to true.
  //  this property does work only in development mode
  const [userData, setUser] = useState({
    user: contextUser,
    initialized: contextUser !== null,
    accessToken: (staticContext || {}).token,
  });
  const setTransition = useTransition()[1];

  useEffect(
    () =>
      onChangeAuthState((currentUser) => {
        setTransition(() => {
          if (currentUser) {
            currentUser
              .getIdTokenResult()
              .then(({ claims }) => {
                const accessToken = documentGetCookie('access_token')
                  ? documentGetCookie('access_token')
                  : currentUser.stsTokenManager.accessToken
                    ? currentUser.stsTokenManager.accessToken
                    : null;

                setUser({
                  user: { ...getUserFields(claims) },
                  initialized: true,
                  accessToken: accessToken || undefined,
                });
              })

              .catch(() => {
                setUser({ user: null, initialized: true, accessToken: undefined });
              });
          } else {
            setUser({ user: null, initialized: true, accessToken: undefined });
          }
        });
      }),
    [],
  );

  useEffect(
    () =>
      onChangeIdToken((currentUser) => {
        setTransition(() => {
          if (currentUser) {
            currentUser
              .getIdToken()
              .then((token) => {
                documentSetCookie('access_token', token);
              })
              .catch(() => {
                documentSetCookie('access_token', '');
              });
          }
        });
      }),
    [],
  );

  return <UserContext.Provider value={userData}>{children}</UserContext.Provider>;
};
